import { Link } from "react-router-dom";
import { Badge, CardBody, Col, Row } from "reactstrap";
import { IoPeopleOutline } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { AWS_S3_URL } from "../../../../../../../utils/constants";
import { EmptyState, SectionCard } from "../../../../../components/Record";
import { personName } from "../../../../../utils/helpers";

function ParticipantsSection({ meetingData }) {
  const { t } = useTranslation();
  const participants = meetingData?.participants ?? [];

  return (
    <SectionCard
      id="participants-informations-card"
      icon={<IoPeopleOutline size={15} />}
      title={t('crm.participants')}
      count={participants.length}
    >
      {participants.length === 0 ? (
        <EmptyState message={t('crm.noRecordsYet')} />
      ) : (
        <CardBody>
          <Row className="g-3">
            {participants.map(participant => {
              const person = participant?.participant;
              const name = person?.company_name || personName(person) || '-';
              const isCustomer = participant?.participant_type === 'customer';

              return (
                <Col md="6" key={participant.id}>
                  <div className="border rounded-3 p-3 h-100 d-flex align-items-center gap-3">
                    {person?.profile_picture_path ? (
                      <img
                        src={AWS_S3_URL + person.profile_picture_path}
                        alt={name}
                        width="40"
                        height="40"
                        className="rounded-circle flex-shrink-0"
                        style={{ objectFit: 'cover' }}
                      />
                    ) : (
                      <div
                        className="rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center fw-bold"
                        style={{ width: 40, height: 40, background: '#f0eeff', color: '#6C63FF', fontSize: '0.8rem' }}
                      >
                        {name.charAt(0).toUpperCase()}
                      </div>
                    )}
                    <div className="overflow-hidden">
                      {isCustomer ? (
                        <Link
                          to={`/crm/customers/view/${participant.participant_id}`}
                          className="crm-record-value fw-semibold text-decoration-none d-block text-truncate"
                        >
                          {name}
                        </Link>
                      ) : (
                        <div className="crm-record-value fw-semibold text-truncate">{name}</div>
                      )}
                      <div className="text-muted text-truncate" style={{ fontSize: '0.78rem' }}>
                        {person?.email || person?.primary_email || '-'}
                      </div>
                    </div>
                    <Badge color="light" className="ms-auto flex-shrink-0">
                      {isCustomer ? t('crm.customer') : t('common.employee')}
                    </Badge>
                  </div>
                </Col>
              );
            })}
          </Row>
        </CardBody>
      )}
    </SectionCard>
  );
}

export default ParticipantsSection;
